import * as React from "react";
import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { decode } from "html-entities";

export default function WebformItem(props) {
  const system = useSelector((state) => state.systemReducer);
  const webform = props.webform;

  const itemToggle = () => {
    if (
      props.selectedWebforms.filter((item) => {
        return item.nid === webform.nid;
      }).length > 0
    ) {
      props.removeSelectedWebformItem(webform);
    } else {
      props.addSelectedWebformItem(webform);
    }
  };

  return (
    <div
      key={`webform-item-${webform.nid}`}
      className={`webform-item ${
        props.selectedWebforms.filter((item) => {
          return item.nid === webform.nid;
        }).length > 0
          ? "selected"
          : ""
      }`}
      onClick={() => itemToggle()}
    >
      {props.selectedWebforms.filter((item) => {
        return item.nid === webform.nid;
      }).length > 0 && <div className="selected-webform-item-marker"></div>}

      {props.selectedWebforms.filter((item) => {
        return item.nid === webform.nid;
      }).length > 0 && (
        <svg
          className="selected-webform-item-marker-check"
          focusable="false"
          aria-hidden="true"
          viewBox="0 0 24 24"
          data-testid="CheckIcon"
        >
          <path d="M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
        </svg>
      )}
      <div className="webform-item-image">
        <img src={`https://${system.subdomain}.companyapp.net${webform.field_featured_image}`} />
      </div>
      <div className="webform-item-title">{decode(webform.title)}</div>
    </div>
  );
}
